/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AbsenceEntry } from '../../models/absence-entry';

export interface ApiV0AbsenceEntryCreateAbsenceEntryPost$Params {
      body?: AbsenceEntry
}

export function apiV0AbsenceEntryCreateAbsenceEntryPost(http: HttpClient, rootUrl: string, params?: ApiV0AbsenceEntryCreateAbsenceEntryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0AbsenceEntryCreateAbsenceEntryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0AbsenceEntryCreateAbsenceEntryPost.PATH = '/api/v0/absenceEntry/createAbsenceEntry';
